// extracted by mini-css-extract-plugin
export var modal = "_ty-0";
export var table = "_ty-1";